import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';

const FundSubscriberDataConsumersProviderMain = () => {
   let {id} = useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
    console.log('location', location)
    const goBack = () => {
      navigate(-1);
    }
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname=="/admin-panel/CheckProviderDetail/PermissionsDetail"? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>    <Button variant="contained"  onClick={goBack} style={{ marginRight: "20px",backgroundColor:"black" }}>
         {"< Back"}
        </Button> Fund Subscribers Fund Transactions</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>     
   

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.ConsumerPurchasedDataUnitsTable id={id}/>    
                            </div>  
                            
            </div>
         
</div>}
</>
  )
}

export default FundSubscriberDataConsumersProviderMain